import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error file not migrated yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useContactInfluencedCampaigns } from './hooks/useContactInfluencedCampaigns';
import Raven from 'raven-js';
import { CAMPAIGN_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CAMPAIGNS_INFLUENCE_KB_URL = 'https://knowledge.hubspot.com/campaigns/understand-campaign-metrics#influenced-contacts';
const CampaignFooterInfluenceSummary = ({
  contactId
}) => {
  const sendOpenInfluencedCampaignsPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_INFLUENCED_CAMPAIGNS_PANEL);
  const {
    campaigns: campaignIds,
    loading: campaignsLoading,
    hasData,
    refetch
  } = useContactInfluencedCampaigns(contactId);

  // Listen for association updates to refetch campaign data
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS, ({
    toObjectTypeId: messageToObjectTypeId,
    objectTypeId: messageObjectTypeId,
    objectId: messageObjectId
  }) => {
    // Check if this is a campaign association update involving the current contact
    const isContactAssociationUpdate = messageObjectTypeId === CONTACT_TYPE_ID && +messageObjectId === contactId && messageToObjectTypeId === CAMPAIGN_TYPE_ID;

    // Check if this is a campaign being associated/disassociated with any contact
    const isCampaignAssociationUpdate = messageObjectTypeId === CAMPAIGN_TYPE_ID && messageToObjectTypeId === CONTACT_TYPE_ID;
    if (isContactAssociationUpdate || isCampaignAssociationUpdate) {
      setTimeout(() => {
        refetch().catch(err => {
          Raven.captureException(err);
        });
      }, 10000);
    }
  });
  function onShowInfluencedCampaigns() {
    sendOpenInfluencedCampaignsPanel({
      contactId
    });
  }
  if (campaignsLoading || !hasData) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    marginBlockStart: "200",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      marginBlockEnd: "100",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `cardAssociatedObjects.ContactInfluencedCampaignsObjectsCardContent.title_jsx`,
        options: {
          count: campaignIds.length
        },
        elements: {
          HelpIcon: () => /*#__PURE__*/_jsx(HelpIcon, {
            alignWithText: true,
            title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "cardAssociatedObjects.ContactInfluencedCampaignsObjectsCardContent.tooltip_jsx",
              elements: {
                KnowledgeBaseButton
              },
              options: {
                url: CAMPAIGNS_INFLUENCE_KB_URL
              }
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(Link, {
      onClick: onShowInfluencedCampaigns,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.ContactInfluencedCampaignsObjectsCardContent.linkText"
      })
    })]
  });
};
export default CampaignFooterInfluenceSummary;